module.exports = __webpack_public_path__ + "img/Einsatzleiter_Rettungsdienst.8677b527.svg";